import { render, staticRenderFns } from "./devices-table.vue?vue&type=template&id=1b18805b&scoped=true&"
import script from "./devices-table.vue?vue&type=script&lang=js&"
export * from "./devices-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18805b",
  null
  
)

export default component.exports